var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SupportMenu } from "./support";
import React, { useEffect } from "react";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import { useNavigate, useParams } from "react-router";
import headphones from "../../assets/icons/feather/headphones.svg";
import { isMobile } from "../../App";
import { Link } from "react-router-dom";
import paths from "../../paths";
import "./support.css";
export function SupportContact() {
    var _this = this;
    var _a = React.useState([]), subjects = _a[0], setSubjects = _a[1];
    var _b = React.useState([]), issues = _b[0], setIssues = _b[1];
    var _c = React.useState(false), ticketForm = _c[0], showTicketForm = _c[1];
    var _d = React.useState(null), hint = _d[0], setHint = _d[1];
    var navigate = useNavigate();
    var params = useParams();
    var pathname = useNavigate();
    useEffect(function () {
        api.start('get', env.accounting_api + '/misc/api/list-questions/', null, false)
            .then(function (res) {
            if (params.id) {
                getIssues(Number(params.id)).finally(function () {
                    setSubjects(res.data);
                });
            }
            else {
                setSubjects(res.data);
            }
        });
    }, []);
    useEffect(function () {
        if (!params.id) {
            setIssues([]);
        }
    }, [pathname]);
    var getIssues = function (e) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (Number(e) === -1) {
                        setIssues([]);
                        setHint(null);
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, api.start('post', env.accounting_api + '/misc/api/list-questions/', { 'question_type': e }, false)
                            .then(function (res) {
                            setIssues(res.data);
                            navigate("".concat(paths.support.url, "/sikca-sorulan-sorular/").concat(e, "/"));
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "row" }, { children: [_jsx("div", __assign({ className: "col-3 col-mobile-12 ".concat(isMobile ? 'account-menu-desktop-only' : '') }, { children: _jsx(SupportMenu, {}) })), _jsxs("div", __assign({ className: "col-9 col-mobile-12 ".concat(isMobile ? 'account-content-mobile' : '') }, { children: [isMobile && _jsx(SupportMenu, {}), _jsxs("div", __assign({ className: "account-info-container" }, { children: [_jsxs("div", __assign({ className: "account-info-header" }, { children: [_jsx("div", __assign({ className: "account-info-header-text" }, { children: "\u0130LET\u0130\u015E\u0130M B\u0130LG\u0130LER\u0130" })), _jsx(Link, __assign({ to: 'tel:08502419099', className: "account-info-header-action support-action-button" }, { children: _jsx("img", { src: headphones, alt: "Call" }) }))] })), _jsx("div", __assign({ className: "account-info-main" }, { children: _jsxs("div", __assign({ className: "account-info-form" }, { children: [_jsxs("div", __assign({ className: "account-info-section" }, { children: [_jsx("div", __assign({ className: "account-info-section-title" }, { children: "M\u00FC\u015Fteri Hizmetleri" })), _jsxs("div", __assign({ className: "account-info-description" }, { children: [_jsx("strong", { children: "\u00C7al\u0131\u015Fma saatleri:" }), _jsx("br", {}), "Hafta i\u00E7i 09:00 - 18:00 ", _jsx("br", {}), "Hafta sonu 09:00 - 18:00 ", _jsx("br", {}), "Destek Hatt\u0131: ", _jsx("a", __assign({ href: "tel:08502419099", className: "account-info-link" }, { children: " 0850 241 90 99 " }))] }))] })), _jsxs("div", __assign({ className: "account-info-section" }, { children: [_jsx("div", __assign({ className: "account-info-section-title" }, { children: "E-Posta Adresi" })), _jsx("div", __assign({ className: "account-info-description" }, { children: "info@e-sans.com.tr" }))] })), _jsxs("div", __assign({ className: "account-info-section" }, { children: [_jsx("div", __assign({ className: "account-info-section-title" }, { children: "Genel M\u00FCd\u00FCrl\u00FCk" })), _jsx("div", __assign({ className: "account-info-description" }, { children: "Maslak Mh. B\u00FCy\u00FCkdere Cd. No:245, USO Center, Kat:10, no:36-37 Sar\u0131yer/\u0130stanbul" }))] })), _jsxs("div", __assign({ className: "account-info-section" }, { children: [_jsx("div", __assign({ className: "account-info-section-title" }, { children: "Mersis" })), _jsx("div", __assign({ className: "account-info-description" }, { children: "0001213671200001" }))] })), _jsxs("div", __assign({ className: "account-info-section" }, { children: [_jsx("div", __assign({ className: "account-info-section-title" }, { children: "Ticaret Sicil Numaras\u0131" })), _jsx("div", __assign({ className: "account-info-description" }, { children: "287309-5" }))] })), _jsxs("div", __assign({ className: "account-info-section" }, { children: [_jsx("div", __assign({ className: "account-info-section-title" }, { children: "Kep Adresi" })), _jsx("div", __assign({ className: "account-info-description" }, { children: "106.dijital@hs01.kep.tr" }))] }))] })) }))] }))] }))] })) }));
}
